import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADGPO entity - alias of ADObject
 * Represents Active Directory Group Policy Objects
 */
export const adGPOEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADGPO', display: 'AD GPO' },
  alias: 'ADObject',
};
